import { JourneysItemInterface } from '@interface/journeys';

export function hasOpacity(status: JourneysItemInterface['status']) {
  const isOpacity =
    status.slug === 'canceled' ||
    status.slug === 'unrecognized' ||
    status.slug === 'refused';
  return isOpacity;
}
